export default __webpack_public_path__ + "static/media/seeker-1.c0874aac.jpg";